"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPinRefByPosition = buildPinRefByPosition;
exports.duplicateNumericPinNumbers = duplicateNumericPinNumbers;
function buildPinRefByPosition(pinNumberByPosition) {
    const positionsByNumber = new Map();
    for (const [position, pinNumber] of pinNumberByPosition) {
        let positions = positionsByNumber.get(pinNumber);
        if (!positions) {
            positions = [];
            positionsByNumber.set(pinNumber, positions);
        }
        positions.push(position);
    }
    const refByPosition = new Map();
    for (const [position, pinNumber] of pinNumberByPosition) {
        refByPosition.set(position, pinNumber);
    }
    const usedRefs = new Set(pinNumberByPosition.values());
    for (const [pinNumber, positions] of positionsByNumber) {
        if (positions.length < 2) {
            continue;
        }
        const sorted = [...positions].sort((a, b) => a - b);
        for (const position of sorted.slice(1)) {
            let candidate;
            candidate = `${pinNumber}@${position}`;
            while (usedRefs.has(candidate)) {
                candidate = `${candidate}@${position}`;
            }
            usedRefs.add(candidate);
            refByPosition.set(position, candidate);
        }
    }
    return refByPosition;
}
function duplicateNumericPinNumbers(pinNumberByPosition) {
    const counts = new Map();
    for (const pinNumber of pinNumberByPosition.values()) {
        if (/^\d+$/.test(pinNumber)) {
            counts.set(pinNumber, (counts.get(pinNumber) ?? 0) + 1);
        }
    }
    return [...counts].filter(([, count]) => count > 1).map(([pinNumber]) => pinNumber);
}
//# sourceMappingURL=orcadPinRefs.js.map